import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { baseurl, imageUrl } from "../Baseurl";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import noproduct from "../component/img/product_not_found.jpeg";

// Custom Arrow Button
const ArrowButton = ({ className, style, onClick, icon }) => {
  return (
    <button
      className={className}
      style={{ ...style, display: 'block', background: 'transparent', border: 'none', color: '#fff',
        backgroundColor: "#000000d3" }}
      onClick={onClick}
    >
      {icon}
    </button>
  );
};


const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllTestimonials`);
        setTestimonials(res.data || []);
      } catch (err) {
        console.error("Failed to fetch testimonials", err);
      }
    };
    fetchTestimonials();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    lazyLoad: "ondemand",
    arrows: true,
    prevArrow: <ArrowButton className="slick-prev" icon="❮" />,
    nextArrow: <ArrowButton className="slick-next" icon="❯" />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1, arrows: false } },
      { breakpoint: 480, settings: { slidesToShow: 1, arrows: false } },
    ],
  };

  return (
    <>
      <section className="testimonial-section">
        <div className="container">
          <div className="mb-1">
            <span className="section-label">TESTIMONIAL</span>
            <h2 className="section-title">
              Client Feedback and Success Stories
            </h2>
          </div>

          <Slider {...settings}>
            {testimonials.map((item, index) => (
              <div className="testimonial-card-wrapper" key={index}>
                <div className="testimonial-card">
                  <div className="testimonial-header">
                    {/* <img
                      src={
                        item.profile
                          ? imageUrl + item.profile
                          : noproduct
                      }
                      alt={item.name}
                      className="avatar"
                    /> */}
                    <div className="text-center">
                      <h5>{item.name}</h5>
                      <p className="role">Customer</p>
                    </div>
                  </div>
                  <p className="testimonial-text">{item.review}</p>
                  <div className="stars">{"★".repeat(item.stars)}</div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
